import React, { useState, useEffect, useRef } from 'react';
import {
  Avatar, Box, Badge, Button, Grid, TextField, FormControlLabel, Switch, FormControl,
  MenuItem, InputAdornment, Checkbox,
  IconButton, Typography,
  Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Snackbar
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import EventIcon from '@mui/icons-material/Event';
import { FaPlusCircle } from 'react-icons/fa';
// import { LuPlusCircle } from "react-icons/lu";
import axios from 'axios';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { useCreateCardDetailContext } from '../../../CreatecardDetailContext';
import { useCardDetailContext } from '../../../CardDetailContext';
import { useUserDetailContext } from '../../../UserDetailContext';
import FileDragUpload from '../../../Utilities/FileDragUpload';
import Autocomplete from '@mui/material/Autocomplete';
// import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
// import { hobbiesSections } from '../../../Utilities/HobbiesContext';
// import { styled } from '@mui/material/styles';
// import ControlPointIcon from '@mui/icons-material/ControlPoint';
import FileDragUploadWithContext from "../../../Utilities/FileDragUploadWithContext";
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useQuantityContext } from '../../../QuantityContext';
import CloseIcon from '@mui/icons-material/Close';
import useApi from '../../../Utilities/useAPI';

const GenzProfileDetails = ({ handleSuccess, handleFailure }) => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem('objectId');
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };
  const { setIsPersonalDetailsSaved, cardDetails, ContactStyles, setCardDetails, updateCardDetails, updateCardStyles, updateCardQrStyles, updateSocialLinks2, updateContactStyles } = useCreateCardDetailContext();
  const { cards, userDetails, setUserDetails } = useUserDetailContext();
  const { callApiFunction } = useApi();

  const { setisNavigationBlocked } = useQuantityContext();
  const [initialCardDetails, setInitialCardDetails] = useState({}); // Define initialCardDetails here

  const fullName = userDetails.name;
  const [firstName, lastName] = fullName.split(' ');
  const [SaveEnable, setSaveEnable] = useState(false);
  const [image, setImage] = useState(null);

  const [cropperVisible, setCropperVisible] = useState(false);
  const cropperRef = useRef(null);
  const [dob, setDOB] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [ProfilePicture, setProfilePicture] = useState('');
  const [CompanyLogo, setCompanyLogo] = useState('');
  // const dateOfBirth = cardDetails && cardDetails.DOB ? cardDetails.DOB.split('T')[0] : '';

  const [searchText1, setSearchText1] = useState(cardDetails.institute || '');
  const [selectedUniversity1, setSelectedUniversity1] = useState(null);
  const [searchText2, setSearchText2] = useState(cardDetails.board || '');
  const [selectedUniversity2, setSelectedUniversity2] = useState(null);

  const [profOpen, setProfOpen] = useState(true);
  const [acadOpen, setAcadOpen] = useState(true);
  const [isPursuing, setIsPursuing] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [cropperInitialized, setCropperInitialized] = useState(false);
  const [maxDate, setMaxDate] = useState('');

  const [isDialogNewEmail, setisDialogNewEmail] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [emailId, setemailId] = useState(ContactStyles.email);
  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showCodeError, setShowCodeError] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  const [showCode, setShowCode] = useState(false);
  const [isDomainVerified, setDomainVerified] = useState(false);


  const { handleInfo } = useQuantityContext();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({ title: '', body: '' });

  // const getProfFieldValue = (field) => professionOpen ? ProfessionalEdited[field] : ProfessionalDetails[field];
  const isCollege = cardDetails?.education_level === 'UG' || cardDetails?.education_level === 'PG' || cardDetails?.education_level === 'HigherEd';

  const [currentEducation, setCurrentEducation] = useState({
    studentId: '',
    verifyMethod: '',
    adminEmailId: '',
    studentEmailId: '',
    verifyDoc: { name: '', type: '', data: '' },
    isVerified: false
  });

  useEffect(() => {
    setSaveEnable(JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails));
    setisNavigationBlocked(JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails));
  }, [cardDetails, initialCardDetails]);

  useEffect(() => {
    setInitialCardDetails(cardDetails);
    const today = new Date().toISOString().split('T')[0];
    setMaxDate(today);
  }, []);

console.log("useCardDetailContext", useCardDetailContext)

  const handlecloseDialog = () => {
    setCode('');
    setErrorMessage('');
    setemailId(ContactStyles.email);
    setisDialogNewEmail(false);
    // setisDialogOldEmail(false);
  }


  // useEffect(() => {
  //     // Start the timer only when TwoFactorAuthSecondPage becomes true
  //     const interval = setInterval(() => {
  //         if (minutes === 0 && seconds === 0) {
  //             setCode('');
  //             clearInterval(interval);
  //         }
  //         else {
  //             // Decrease seconds if greater than 0
  //             if (seconds > 0) {
  //                 setSeconds(seconds - 1);
  //             } else {
  //                 if (minutes > 0) {
  //                     setMinutes(minutes - 1);
  //                     setSeconds(59); // Reset seconds to 59 when minutes decrease
  //                 }
  //             }
  //         }
  //     }, 1000);

  //     return () => {
  //         clearInterval(interval);
  //     };

  // }, [seconds, minutes]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    setSelectedFile(file);
    setSelectedImage(imageUrl);
    setOpenDialog(true);
  };

  const handleCropSave = () => {
    console.log("Clicking save button");

    if (!cropperRef.current || !cropperRef.current.getCroppedCanvas) {
      console.error("Cropper not initialized or getCroppedCanvas function not available.");
      return;
    }

    const canvas = cropperRef.current.getCroppedCanvas();

    if (canvas) {
      canvas.toBlob(
        (blob) => {
          const croppedFile = new File([blob], selectedFile.name || 'croppedImage.jpg', {
            type: selectedFile.type || 'image/jpeg',
          });

          // Update selected image state
          setSelectedImage(URL.createObjectURL(croppedFile));

          // Prepare image object for form data
          const imageObject = {
            name: croppedFile.name,
            type: croppedFile.type,
            data: URL.createObjectURL(croppedFile),
          };

          // Update form data with cropped image object
          updateCardDetails({ profile_pic: imageObject });

          // Close dialog after cropping
          setOpenDialog(false);

          // Upload the cropped file
          handleFileUpload(croppedFile);
        },
        'image/jpeg'
      );
    } else {
      console.error("Canvas not available after cropping.");
    }
  };

  useEffect(() => {
    if (openDialog && selectedImage && !cropperInitialized && cropperRef.current) {
      console.log("Initializing cropper...");
      setCropperInitialized(true);
    }
  }, [openDialog, selectedImage, cropperInitialized]);

  // Function to handle cropper initialization
  const handleCropperInitialized = (instance) => {
    cropperRef.current = instance;
  };

  // Effect to initialize cropper once selected image changes
  useEffect(() => {
    if (openDialog && selectedImage && !cropperInitialized && cropperRef.current) {
      console.log("Initializing cropper...");
      setCropperInitialized(true);
    }
  }, [openDialog, selectedImage, cropperInitialized]);

  // Function to handle cropper initialization
  const getCroppedCanvas = (instance) => {
    cropperRef.current = instance;
  };

  useEffect(() => {
    if (openDialog && selectedImage) {
      setCropperInitialized(false);
    }
  }, [selectedImage]);

  // Function to handle file upload to server
  const handleFileUpload = async (file) => {
    if (!file) {
      console.error('No file to upload.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Assuming your response structure is like { sasUrl: 'some_url' }
      const sasUrl = response.data.url;

      console.log("File uploaded successfully!", sasUrl);

      updateCardDetails({ profile_pic: sasUrl });
      setSelectedImage(null);
      setSelectedFile(null);
      // Proceed to next step or perform necessary actions after upload
      // setActiveStep((prevActiveStep) => prevActiveStep + 1);

    } catch (error) {
      console.error('Error uploading file:', error.message);
      handleFailure('Error uploading file. Please check the console for details.');
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateCardDetails({ [fieldName]: newValue });
  };

  const [cardNameError, setCardNameError] = useState('');
  const handleChangeCardName = (event) => {
    const newValue = event.target.value;
    updateCardDetails({ CardName: newValue });
    updateCardStyles({ CardName: newValue });
    updateCardQrStyles({ CardName: newValue });
    updateSocialLinks2({ CardName: newValue });
    updateContactStyles({ CardName: newValue });
  }

  // const handleDOBChange = (event) => {
  //   const dateString = event.target.value;
  //   const dateObject = new Date(dateString);

  //   if (!isNaN(dateObject.getTime())) {
  //     setDOB(dateString);
  //     updateCardDetails({ DOB: dateString });
  //   } else {
  //     console.error('Invalid date');
  //   }
  // };

  const updateContactValue = (fieldName, newValue) => {
    updateContactStyles({ fieldName: newValue });
    updateCardDetails({ ['is_professional_verified']: true });
  };

  const handleDOBChange = (dateString) => {
    const dateObject = new Date(dateString);
    if (!isNaN(dateObject.getTime())) {
      setUserDetails((prevDetails) => ({
        ...prevDetails,
        dob: dateString,
      }));

      setCardDetails((prevDetails) => ({
        ...prevDetails,
        dob: dateString,
        isDbavailable: false
      }));

    } else {
      console.error('Invalid date');
    }
  };

  const handleChangeEducationItems = (fieldName) => (event) => {
    const newValue = event.target.value;
    const updatedField = { [fieldName]: newValue };
    const updatedEducation = { ...currentEducation, ...updatedField };
    updateCurrentEducation(updatedField);


  };

  const updateCurrentEducation = (updatedField) => { //with both Key and Pair
    setCurrentEducation((prevEducation) => ({
      ...prevEducation,
      ...updatedField,
    }));
  };
  const [saveHittedFirst, setsaveHitted] = useState(false);
  const handleSave = async (event) => {
    event.preventDefault();

    const invalidCardNames = ['Personal', 'Professional', 'Student', 'GenZ'];
    if (cardDetails?.CardType?.startsWith("Customize_") && (cardDetails.CardName === '' || cardDetails.CardName === null)) {
      // alert("CardName should not be Empty");
      handleInfo("CardName should not be Empty");
      return;
    }
    if (cards.map(card => card.toLowerCase()).includes(cardDetails.CardName.trim().toLowerCase())) {
      setCardNameError("Card name should be unique");
      return;
    }
    if (invalidCardNames.includes(cardDetails.CardName.trim())) {
      setCardNameError("Card name already reserved");
      return;
    }

    if (!/^[a-zA-Z\s]*$/.test(cardDetails.CardName)) {
      setCardNameError("Card Name can only contain alphanumeric characters (no spaces or special characters).");
      return;
    }

    if (cardDetails.CardName > 19) {
      setCardNameError("Card Name must be 19 characters or less.");
      return;
    }


    // if(cardDetails.CardName === '' || cardDetails.CardName === null){
    //   alert("CardName should not be Empty");
    //   return;
    // }

    event.preventDefault();

    const newCardDetails = {
      User_ID: cardDetails.User_ID,
      CardType: cardDetails.CardType,
      // CardName: cardDetails.CardName,
      CardName: cardDetails?.CardType?.startsWith("Customize_") ? cardDetails?.CardName || "CardName" : cardDetails?.CardType,
      card_mobile: userDetails.phone,
      card_email: userDetails.email,
      created_by: userDetails.name
    };

    try {

      try {
        const response2 = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/addNewCardDetails`, newCardDetails, {
          headers: headers
        });
        setIsPersonalDetailsSaved(true);
      } catch (err) {
        console.log("New Card Details already exist or Error occured");
      }

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/personaldata`, cardDetails, {
        headers: headers
      });
      console.log('Response from backend:', response);

      setsaveHitted(true);
      setInitialCardDetails(cardDetails);
      handleSuccess();
    }
    catch (error) {
      console.error('Error submitting card details:', error);
      handleFailure();
    }
  };
  const [universities, setUniversities] = useState([]);
  // const [educations] = useState(cardDetails.Education);

  useEffect(() => {
    const fetchUniversityNames = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/universities`, {
          headers: headers
        });
        setUniversities(response.data);
      } catch (error) {
        console.error('Failed to fetch university names:', error);
      }
    };

    fetchUniversityNames();
  }, [apiKey]);

  const handleSearchTextChange1 = (event, value) => {
    // setSearchText1(value);
    setSearchColleges(value);
    updateCardDetails({ institute: value.college_name });
  };

  const handleUniversityChange1 = (event, value) => {
    if (!value) {
      setSelectedUniversity1(null);
      updateCardDetails({ institute: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedUniversity1(value);
      updateCardDetails({ institute: value.college_name });
    }

    if (value && value.university_name) {
      console.log('Selected option:', value);
      setSearchUniversity(value.university_name);
      setSelectedUniversity2({ name: value.university_name });
      updateCardDetails({ board: value.university_name });
    } else {
      setSearchUniversity('');
      setSelectedUniversity2(null);
      updateCardDetails({ board: '' });
    }
  };

  const handleSearchTextChange2 = (event, value) => {
    // setSearchText2(value);
    setSearchUniversity(value);
    updateCardDetails({ board: value.name });
  };

  // const handleUniversityChange2 = (event, value) => {
  //   setSelectedUniversity2(value);
  //   updateCardDetails({ board: value });
  // };

  const handleUniversityChange2 = (event, value) => {
    // Handle null values when the field is cleared
    if (!value) {
      setSelectedUniversity2(null);
      updateCardDetails({ board: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedUniversity2(value);
      updateCardDetails({ board: value.name }); // Use the correct field
    }
  };

  // const uniqueUniversities1 = universities.filter((university) => university.toLowerCase().includes(searchText1.toLowerCase()));
  // const uniqueUniversities2 = universities.filter((university) => university.toLowerCase().includes(searchText2.toLowerCase()));

  // Ensure unique keys for Autocomplete options
  // const filteredUniversities1 = Array.from(new Set(uniqueUniversities1));
  // const filteredUniversities2 = Array.from(new Set(uniqueUniversities2));

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    updateCardDetails({ student_currently_pursuing: checked });
    if (checked) {
      updateCardDetails({ student_ending_year: 'Present' });
    } else {
      updateCardDetails({ student_ending_year: '' });
    }
  };

  const [openDialogForNewField, setOpenDialogForNewField] = useState(false);
  const [newFieldName, setNewFieldName] = useState('');
  const [newFieldValue, setNewFieldValue] = useState('');

  const handleAddField = () => {
    if (newFieldName && newFieldValue) {
      setCardDetails(prevDetails => ({
        ...prevDetails,
        additionalFields: {
          ...prevDetails.additionalFields,
          [newFieldName]: newFieldValue
        }
      }));
      setNewFieldName('');
      setNewFieldValue('');
      setOpenDialogForNewField(false);
    }
  };

  const handleFieldChange = (key, event) => {
    setCardDetails(prevDetails => ({
      ...prevDetails,
      additionalFields: {
        ...prevDetails.additionalFields,
        [key]: event.target.value
      }
    }));
  };

  const handleRemoveField = (key) => {
    const { [key]: removedField, ...remainingFields } = cardDetails.additionalFields;
    setCardDetails(prevDetails => ({
      ...prevDetails,
      additionalFields: remainingFields
    }));
  };

  const handleVerify = async (event) => {
    event.preventDefault();


    if (currentEducation.verifyMethod == 'studentEmailId') {
      //    alert(cardDetails.student_email_id)
      if (cardDetails.student_email_id) {

        try {
          const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify/get-url-data`, {
            "student_email": cardDetails.student_email_id,
            "logo_fetch": false
          }, {
            headers: headers
          });

          console.log('Response from backend veirfy:', response.data.data.studentEmail);

          if (response.data.data.studentEmail) {
            SendingOTP();
            setisDialogNewEmail(true)
          }


        }
        catch (error) {
          console.error('Error verifying details:', error);

        }

      }
    }

    else if (currentEducation.verifyMethod === 'adminEmailId') {

      if (currentEducation.adminEmailId) {
        const formData = new FormData();
        formData.append('studentDetails', JSON.stringify({
          selectedOption: 'admin_mail',
          name: userDetails?.name || 'User',
          student_id: cardDetails?.student_id || ''
          ,
          card_name: cardDetails?.CardName,
          card_type: cardDetails?.CardType,
          admin_email: currentEducation.adminEmailId
        }));

        // Append the file if you have one, for example, `file` is obtained from a file input
        // formData.append('documents', file);  // Uncomment this line if you have a file to upload



        try {
          setPageLoading(true);
          const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/verification-option`, formData, { headers });

          console.log('Response from backend status:', response.data.status);

          if (response.data.status === 'SUCCESS') {
            setPageLoading(false);
            handleSuccessCustomMessage(response.data.message)
            handleSaveCustom()
          } else if (response.data.status === "ERROR") {
            setPageLoading(false);
            handleFailureCustomMessage(response.data.message)
          }

        } catch (error) {
          console.error('Error verifying details:', error);
          setPageLoading(false);
          handleFailureCustomMessage()
          // alert('Error verifying details. Please try again.');
        }

      }
    }




  };

  const handleSuccessCustomMessage = (message) => {
    let successMessage = message ? message : 'Success !!'
    setSnackbarMessage({
      title: '',
      body: successMessage
    });
    setSnackbarOpen(true); // Open the Snackbar
  };

  const handleFailureCustomMessage = (message = '') => {
    let failureMessage = message ? message : 'Something went wrong'
    setSnackbarMessage({
      title: '',
      body: failureMessage
    });
    setSnackbarOpen(true); // Open the Snackbar
  };

  const handleSaveCustom = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/personaldata`, cardDetails, {
        headers: headers
      });

      console.log('Response from backend:', response.data);
      setInitialCardDetails(cardDetails);
      handleSuccess();
    }
    catch (error) {
      console.error('Error submitting card details:', error);
      handleFailure();
    }
  };

  const toggleCodeVisibility = () => {
    setShowCode(prev => !prev);
  };

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
    setErrorMessage('');
  };

  const handleCodeSubmitNewEmail = async () => {
    try {
      // Proceed with OTP verification
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`, {
        email: emailId,
        otp: code,
      }, { headers: headers })
        .then(async (response) => {
          setCode('');
          setErrorMessage('');
          setisDialogNewEmail(false);
          const domainVerified = await checkDomainVerification(emailId)
          console.log("checking domain:", domainVerified);
          console.log("checking response:", response);
          // if (domainVerified) {
          updateCardDetails({ professional_email_id: emailId });
          console.log("OTP verified successfully");
          // await updateLogoInCard(emailId)
          updateContactValue('email', emailId);
          // } 
          // else {
          //     setErrorMessage("Domain is not verified. Please use a Correct Professional email.");
          // }
        })
        .catch(error => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify OTP:", error);
        });
    } catch (error) {
      console.error("Error in domain verification or OTP submission:", error);
    }
  };

  const isEnableVerifyButton = () => {
    let requiredFields = [
      'education_level',
      'field_of_study',
      'grade',
      'degree',
      'student_id',
      'student_email_id',
      'student_year',
      'student_ending_year',
    ];

    const isCommonFieldsFilled = requiredFields.every(field => cardDetails[field]);

    if (!isCommonFieldsFilled) return false;

    // Check fields based on the selected verifyMethod
    if (currentEducation.verifyMethod === 'studentEmailId') {
      return cardDetails.student_email_id !== '';
    } else if (currentEducation.verifyMethod === 'adminEmailId') {
      return currentEducation.adminEmailId !== '';
    } else if (currentEducation.verifyMethod === 'verifyDoc') {
      return currentEducation?.verifyDoc && currentEducation.verifyDoc.data !== '';
    }

    return false;
  }


  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  );

  const sendOtpNewEmail = () => {

    // return false;
    SendingOTP();
  }

  const checkVerifyProfButton = () => {
    return true
  }

  const checkDomainVerification = async (email) => {
    setPageLoading(true);
    const defaultLogo = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR_M8aMgLLBf3wTDkl43nyAXw0VNzPcRjTsSw&s";
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify/get-company-data`, {
        email: email,
        cardName: cardDetails.CardName,
        cardType: cardDetails.CardType
      }, { headers: headers }
      );
      // console.log("response", response)

      if (response.data.logoUrl) {
        const fetchedLogo = response.data.logoUrl;
        try {
          const logoResponse = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/card/personaldata`, { logo: fetchedLogo }, {
            headers: headers
          });
          if (logoResponse.status === 201)
            updateCardDetails({ 'logo': fetchedLogo });
        } catch (error) {
          console.log('Could not set the fetched logo:', fetchedLogo);
        }
      }

      if (response.data.isDomainVerified) {
        setDomainVerified(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Failed to check domain verification:", error);
      return false;
    } finally {
      setPageLoading(false);
    }
  };

  const SendingOTP = async () => {
    setMinutes(0);
    setSeconds(60);
    setisDialogNewEmail(true);
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`, {
      email: `${emailId}`,
    }, { headers: headers })
      .then(response => {
        console.log("OTP sent successfully");
      })
      .catch(error => {
        // Handle error, such as displaying an error message to the user
        console.error("Failed to send OTP:", error);
      });

  };

  // Integrating new Colleges List API
  const [searchColleges, setSearchColleges] = useState(cardDetails?.institute);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [searchUniversity, setSearchUniversity] = useState(cardDetails?.board);
  const [filteredUniversities, setFilteredUniversities] = useState([]);
  const [offset, setOffset] = useState({
    colleges: 0,
    universities: 0
  });
  const [hasMoreItems, setHasMoreItems] = useState({
    colleges: true,
    universities: true
  }); // To track if more results are available
  const limit = 20;

  const fetchCollegesList = async () => {
    try {
      const reqObject = {
        search: searchColleges,
        limit: limit,
        offset: offset.colleges
      };
      const response = await callApiFunction('getCollegesList', reqObject);

      if (response.status === "SUCCESS") {
        const allColleges = response.data.colleges;

        // If less than 20 colleges are fetched, no more data is available
        if (allColleges?.length < limit) {
          setHasMoreItems(prevState => ({ ...prevState, colleges: false }));
        }

        setFilteredColleges(prevColleges => [...prevColleges, ...allColleges]);
      } else {
        console.error('Failed to fetch college data.');
      }
    } catch (err) {
      console.error('An error occurred while fetching college data.', err);
    }
  };

  const fetchUniversitiesList = async () => {
    try {
      const reqObject = {
        search: searchUniversity,
        limit: limit,
        offset: offset.universities
      };
      const response = await callApiFunction('getUniversitiesList', reqObject);

      if (response.status === "SUCCESS") {
        const allUniversities = response.data.universities;
        
        // If less than 20 colleges are fetched, no more data is available
        if (allUniversities?.length < limit) {
          setHasMoreItems(prevState => ({ ...prevState, universities: false }));
        }

        setFilteredUniversities(prevUniversities => [...prevUniversities, ...allUniversities]);
      } else {
        console.error('Failed to fetch University data.');
      }
    } catch (err) {
      console.error('An error occurred while fetching university data.', err);
    }
  };

  // Scroll event handler to detect if the user has reached the bottom of the dropdown
  const handleDropdownScroll = (event, listName = 'colleges') => {
    const bottom =
      event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;

    if (bottom && hasMoreItems[listName]) {
      // Increment the offset for the correct list (colleges or universities)
      setOffset(prevOffset => ({
        ...prevOffset,
        [listName]: prevOffset[listName] + limit // Increment the correct offset key
      }));
    }
  };

  // useEffect to trigger fetch when the offset changes (pagination)
  useEffect(() => {
    if (offset.colleges === 0) return; // Don't fetch data initially unless there's a search
    fetchCollegesList();
  }, [offset.colleges]); // Trigger fetch when colleges offset changes

  useEffect(() => {
    if (offset.universities === 0) return; // Don't fetch data if no search term
    fetchUniversitiesList();
  }, [offset.universities]);

  // useEffect for when College search term changes
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      setFilteredColleges([]); // Clear previous results
      setOffset(prevOffset => ({ ...prevOffset, colleges: 0 })); // Reset offset for new search
      setHasMoreItems(prevState => ({ ...prevState, colleges: true })); // Reset hasMoreItems flag
      fetchCollegesList(); // Initial fetch for new search term
    }, 300);

    return () => clearTimeout(debounceSearch);
  }, [searchColleges]);

  // useEffect for when Universities search term changes
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      setFilteredUniversities([]); // Clear previous results
      setOffset(prevOffset => ({ ...prevOffset, universities: 0 })); // Reset offset for new search
      setHasMoreItems(prevState => ({ ...prevState, universities: true })); // Reset hasMoreItems flag
      fetchUniversitiesList();
    }, 300);

    return () => clearTimeout(debounceSearch);
  }, [searchUniversity]);

  return (
    <div>
      <div className='px-3'>
        <div className="card-edit-info-heading">
          <h5>Profile Information</h5>
          <span>Add your profile information to show in your digital business card</span>
        </div>
        <div className='profile-and-logo my-4 mt-4'>
          <div className='profile-picture-container text-center'>
            <h5>Profile Picture</h5>
            <div>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={
                  <Avatar sx={{ bgcolor: "#0044C6" }}>
                    <label htmlFor="profilePicture-input" style={{ cursor: "pointer" }}>
                      <EditRoundedIcon />
                    </label>
                    <input id="profilePicture-input" type="file" accept='image/*' style={{ display: 'none' }} onChange={handleFileSelect} />
                  </Avatar>}>
                <Avatar sx={{ bgcolor: "#F4F7FE", width: "130px", height: "130px" }}>
                  {cardDetails.profile_pic !== '' ?
                    <img src={cardDetails.profile_pic} alt="profilepicture" className='profile-pic-avatar' />
                    : <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                  }
                </Avatar>
              </Badge>
            </div>
          </div>
          <FileDragUpload label="Add Logo" contextKey="logo" accept={['image/jpeg', 'image/png']} maxSize={1} inputId="companyLogo-input" useContext={useCardDetailContext} />
        </div>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>Crop Image</DialogTitle>
          <DialogContent>
            <div style={{ width: '100%', height: '400px', position: 'relative' }}>
              <Cropper
                ref={cropperRef}
                src={selectedImage}
                style={{ height: '100%', width: '100%' }}
                initialAspectRatio={1}
                guides={true}
                cropBoxMovable={true}
                cropBoxResizable={true}
                crossOrigin="anonymous"
                dragMode="crop"
                viewMode={1}
                background={false}
                responsive={true}
                autoCrop={false}
                autoCropArea={1}
                minCropBoxHeight={20}
                minCropBoxWidth={20}
                checkOrientation={false}
                onInitialized={handleCropperInitialized}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCropSave}>Save</Button>
          </DialogActions>
        </Dialog>

        <div className="my-2 user-details-container">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <FormControl fullWidth>
                    <TextField
                      name="Category"
                      label="Category"
                      required
                      select
                      value={cardDetails.CardType}
                      InputLabelProps={{ required: false }}
                      fullWidth
                      className='textfield-widthNew'
                      disabled
                    >
                      <MenuItem value="GenZ">GenZ</MenuItem>
                      <MenuItem value="Customize_GenZ">Customize</MenuItem>
                    </TextField>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  {cardDetails?.CardType?.startsWith("Customize_") && (
                    <TextField
                      label="Card Name"
                      fullWidth
                      value={cardDetails?.CardName}
                      onChange={handleChangeCardName}
                      disabled={saveHittedFirst}
                      inputProps={{ maxLength: 18 }}
                    />
                  )}
                  {cardNameError && <Typography variant="body2" color="error">{cardNameError}</Typography>}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <div className="my-2 user-details-container">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    label="First Name"
                    fullWidth
                    value={firstName}
                    disabled
                    inputProps={{ maxLength: 90 }}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Date of Birth"
                    type="date"
                    // value={dateOfBirth}
                    value={userDetails?.dob}
                    onChange={(event) => handleDOBChange(event.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        max: maxDate,
                      },
                    }}
                    fullWidth
                    disabled={Boolean(userDetails?.dob)}
                  />
                </Grid>
                <Grid item>
                  <TextField label="Suffix" fullWidth value={cardDetails.suffix} onChange={handleInputChange('suffix')} inputProps={{ maxLength: 8 }} />
                </Grid>
                <Grid item>
                  <TextField
                    label="Title"
                    fullWidth
                    value={cardDetails.title}
                    onChange={handleInputChange('title')}
                    inputProps={{ maxLenght: 22 }}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Second Column */}
            <Grid item xs={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <TextField
                    label="Last Name"
                    fullWidth
                    value={lastName}
                    disabled
                    inputProps={{ maxLength: 90 }}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    label="Prefix"
                    fullWidth
                    value={cardDetails.prefix}
                    onChange={handleInputChange('prefix')}
                    inputProps={{ maxLength: 8 }}
                  />
                </Grid>
                <Grid item>
                  <TextField label="Email" disabled fullWidth value={userDetails.email} inputProps={{ maxLength: 48 }} />
                </Grid>
                <Grid item>
                  <TextField
                    label="Nickname"
                    fullWidth
                    value={cardDetails.nickname}
                    onChange={handleInputChange('nickname')}
                    inputProps={{ maxLength: 18 }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box className={`my-3 genz-prof-fields ${acadOpen ? 'opened' : ''}`} >
            <span>Academic Information</span>
            <IconButton color="inherit" onClick={() => setAcadOpen(!acadOpen)}>
              {acadOpen ? (<RemoveCircleOutlineRoundedIcon />) : (<AddCircleOutlineRoundedIcon />)}
            </IconButton>
          </Box>

          {acadOpen &&
            <>
              <div className='mb-2 confidential-warning'>
                *Student ID and Student Email ID are confidential information and cannot be shared.
              </div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <FormControl fullWidth>
                        <TextField
                          name="Education"
                          label="Education Level"
                          required
                          select
                          value={cardDetails.education_level}
                          onChange={handleInputChange('education_level')}
                          InputLabelProps={{ required: false }}
                          fullWidth
                          className='textfield-widthNew'
                        >
                          <MenuItem value="SSLC">10th/SSLC/SSC</MenuItem>
                          <MenuItem value="HSC">12th/PUC/HSC</MenuItem>
                          <MenuItem value="UG">Undergraduate</MenuItem>
                          <MenuItem value="PG">Post Graduate</MenuItem>
                          <MenuItem value="HigherEd">Higher Education</MenuItem>
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <FormControl fullWidth>
                        <Autocomplete
                          value={selectedUniversity2}
                          onChange={handleUniversityChange2}
                          inputValue={searchUniversity}
                          onInputChange={handleSearchTextChange2}
                          options={isCollege ? filteredUniversities : []}
                          freeSolo
                          getOptionLabel={(option) => (option ? option.name : "")}
                          ListboxProps={{
                            onScroll: (event) => handleDropdownScroll(event, 'universities')
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Board/University"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>

                    {cardDetails.education_level !== 'SSLC' && (
                      <Grid item>
                        <TextField label={cardDetails.education_level === 'HSC' ? 'Subjects' : 'Field of Study'} value={cardDetails.field_of_study} onChange={handleInputChange('field_of_study')} fullWidth inputProps={{ maxLenght: 90 }} />
                      </Grid>
                    )}

                    <Grid item>
                      <TextField label="Student ID" fullWidth value={cardDetails.student_id} onChange={handleInputChange('student_id')} inputProps={{ maxLength: 18 }} />
                    </Grid>
                    <Grid item>
                      <TextField label="Starting Year" fullWidth value={cardDetails?.student_year || ''} onChange={handleInputChange('student_year')}
                        select required>
                        {years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}</TextField>
                    </Grid>
                    <Grid item>
                      <FormControlLabel
                        control={<Checkbox checked={cardDetails?.student_currently_pursuing} onChange={handleCheckboxChange} />}
                        label="Currently Pursuing"
                      />
                    </Grid>
                    <Grid item>



                      <TextField name="verifyMethod" label='Verification Method' onChange={handleChangeEducationItems('verifyMethod')} fullWidth select  >
                        <MenuItem value="studentEmailId">My Institute  E-mail ID</MenuItem>
                        <MenuItem value="adminEmailId">My Institute Admin E-mail ID</MenuItem>
                        <MenuItem value="verifyDoc">Upload Verification Document</MenuItem>
                      </TextField>


                    </Grid>


                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <FormControl fullWidth>
                        <Autocomplete
                          value={selectedUniversity1}
                          onChange={handleUniversityChange1}
                          inputValue={searchColleges}
                          onInputChange={handleSearchTextChange1}
                          options={isCollege ? filteredColleges : []}
                          freeSolo
                          getOptionLabel={(option) => option.college_name || ""}
                          ListboxProps={{
                            onScroll: handleDropdownScroll
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Institute"
                              variant="outlined"
                              fullWidth
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>

                    {cardDetails.education_level === 'SSLC' ? (
                      <Grid item>
                        <TextField label="Grade/GPA" value={cardDetails.grade} onChange={handleInputChange('grade')} fullWidth inputProps={{ maxLength: 18 }} />
                      </Grid>
                    ) : (
                      <Grid item>
                        <TextField label={cardDetails.education_level === 'HSC' ? 'Stream' : 'Degree'} value={cardDetails.degree} onChange={handleInputChange('degree')} fullWidth inputProps={{ maxLength: 48 }} />
                      </Grid>
                    )}

                    {cardDetails.education_level !== 'SSLC' && (
                      <Grid item>
                        <TextField label="Grade/GPA" value={cardDetails.grade} onChange={handleInputChange('grade')} fullWidth inputProp={{ maxLength: 18 }} />
                      </Grid>
                    )}

                    <Grid item>
                      <TextField label="Student Email ID" fullWidth value={cardDetails.student_email_id} onChange={handleInputChange('student_email_id')} inputProps={{ maxLength: 48 }} />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Ending Year"
                        fullWidth
                        value={cardDetails?.student_ending_year || ''}
                        onChange={handleInputChange('student_ending_year')}
                        select
                        disabled={cardDetails?.student_currently_pursuing}
                        required>
                        {years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                        {cardDetails.student_currently_pursuing &&
                          <MenuItem key='Present' value='Present'>
                            Present
                          </MenuItem>}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  {currentEducation.verifyMethod !== '' &&
                    <>

                      {currentEducation.verifyMethod === 'studentEmailId' && (
                        <TextField
                          name="studentId"
                          label='Student Email ID'
                          value={cardDetails?.student_email_id || currentEducation.EmailId}
                          onChange={handleChangeEducationItems('studentEmailId')}
                          fullWidth
                          helperText="Verify your academic details securely using your institute's student ID." required inputProps={{ maxLength: 48 }} />
                      )}
                      {currentEducation.verifyMethod === 'adminEmailId' && (
                        <TextField
                          name="adminId"
                          label='Admin Email ID'
                          value={currentEducation.adminEmailId}
                          onChange={handleChangeEducationItems('adminEmailId')}
                          fullWidth
                          helperText="Verify your academic details securely using your institute's admin ID." inputProps={{ maxLength: 48 }} />
                      )}
                      {currentEducation.verifyMethod === 'verifyDoc' && (
                        <FileDragUploadWithContext
                          label='Upload Verification Document'
                          maxSize={5}
                          inputId='verifyEduDoc'
                          contextKey='verifyDoc'
                          context={currentEducation}
                          updateContext={updateCurrentEducation}
                          accept={["image/jpeg", "image/png", "application/pdf"]}
                        />
                      )}
                    </>
                  }
                </Grid>

                <Grid item xs={12}>
                  <div className="save-bottom" style={{ textAlign: "left" }}>
                    <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleVerify} disabled={!isEnableVerifyButton()}>
                      Verify
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </>
          }

          <Box className={`my-3 genz-prof-fields ${profOpen ? 'opened' : ''}`} >
            <span>Professional Information</span>
            <IconButton color="inherit" onClick={() => setProfOpen(!profOpen)}>
              {profOpen ? (<RemoveCircleOutlineRoundedIcon />) : (<AddCircleOutlineRoundedIcon />)}
            </IconButton>
          </Box>

          {profOpen &&
            <>
              <div className='mb-2 confidential-warning'>
                *Employee ID and Company ID are confidential information and cannot be shared.
              </div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField label="Designation" fullWidth value={cardDetails.designation} onChange={handleInputChange('designation')} inputProps={{ maxLength: 42 }} />
                    </Grid>
                    <Grid item>
                      <TextField label="Company" fullWidth value={cardDetails.company} onChange={handleInputChange('company')} inputProps={{ maxLength: 42 }} />
                    </Grid>
                    <Grid item>
                      <TextField label="Employee ID" fullWidth value={cardDetails.employee_id} onChange={handleInputChange('employee_id')} inputProps={{ maxLength: 18 }} />
                    </Grid>
                    <Grid item>
                      <TextField label="Company Website" fullWidth value={cardDetails.company_website} onChange={handleInputChange('company_website')} inputProps={{ maxLength: 90 }} />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField label="Department" fullWidth value={cardDetails.profession_department} onChange={handleInputChange('profession_department')} inputProps={{ maxLenght: 32 }} />
                    </Grid>
                    <Grid item>
                      <TextField label="Company CIN/ UIN" fullWidth value={cardDetails.company_id} onChange={handleInputChange('company_id')} inputProps={{ maxLength: 18 }} />
                    </Grid>
                    <Grid item>
                      <TextField label="Professional Email ID" fullWidth value={cardDetails.professional_email_id} onChange={handleInputChange('professional_email_id')} inputProps={{ maxLength: 48 }}
                      //  InputProps={{
                      //   endAdornment: (
                      //     <>
                      //       {getProfFieldValue('professional_email_id') ?
                      //         <InputAdornment position="end">
                      //           <VerifiedTick className='green-verified-tick' />
                      //         </InputAdornment>
                      //         : <> </>}
                      //     </>
                      //   )
                      // }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} container alignItems="center">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    onClick={sendOtpNewEmail}
                    disabled={checkVerifyProfButton()}
                  >
                    Verify</Button>
                </Grid>
              </Grid>
            </>
          }

          <Grid className='mt-3 mb-2' container spacing={2}>
            <Grid item xs={12}>
              <Grid item>
                <TextField
                  multiline
                  minRows={4}
                  label="Summary"
                  className='summary-field'
                  fullWidth
                  value={cardDetails.summary}
                  onChange={handleInputChange('summary')}
                  inputProps={{ maxLength: 250 }}
                />
              </Grid>
            </Grid>
            {Object.keys(cardDetails?.additionalFields ?? {}).map((key) => (
              <Grid item xs={6} key={key}>
                <Grid item>
                  <TextField
                    label={key}  // Display the field name
                    value={cardDetails.additionalFields[key]}  // Display the field value
                    onChange={(event) => handleFieldChange(key, event)}
                    fullWidth
                  />
                </Grid>
              </Grid>
            ))}
          </Grid>


          {/* <FormControlLabel className='mt-1' control={<Switch defaultChecked />} label="Enable View" /> */}
        </div>
        {cardDetails?.CardType?.startsWith("Customize_") &&
          <div className="my-2 py-2 d-flex align-items-center color-blue" onClick={() => setOpenDialogForNewField(true)}>
            <div className={`icon me-1 ms-0`}>
              <FaPlusCircle className="color-blue" />
            </div>
            Add More Fields</div>}
      </div>

      <div className="save-bottom" style={{ textAlign: "right", backgroundColor: "#0044C614", padding: "12px", borderRadius: "0 0 8px 8px" }}>
        {/* <Button className="mx-2" variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={() => {console.log("cardDetails:", cardDetails, "\ncardProfDetails:", cardProfDetails, "\ncardAcademyDetails:", cardAcademyDetails)}}>Print Context</Button> */}
        <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleSave} disabled={!SaveEnable}>Save</Button>
      </div>
      <ToastContainer toastClassName="email-toast-success" />

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={
          <div>
            <strong>{snackbarMessage.title}</strong>
            <div>{snackbarMessage.body}</div>
          </div>
        }
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        anchorOrigin={{
          vertical: 'top',    // Position at the top
          horizontal: 'right', // Position at the right
        }}
      />
      <Dialog
        open={openDialogForNewField}
        onClose={() => setOpenDialogForNewField(false)}
        fullWidth
        sx={{ '& .MuiDialog-paper': { maxWidth: '520px' } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Typography variant="h6">Add More Fields</Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpenDialogForNewField(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        </DialogTitle>
        <Typography gutterBottom sx={{ padding: '0 16px', marginBottom: "15px" }}>
          Add custom fields to enhance more details.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '0 16px' }}>
          {Object.keys(cardDetails?.additionalFields ?? {}).map((key) => (
            <>
              <Grid item style={{ width: "85%" }}>
                <TextField
                  placeholder='Name'
                  variant="standard"
                  fullWidth
                  value={key}
                  disabled
                  sx={{ mb: 2 }}
                />
              </Grid>
              <div className='d-flex align-items-center' style={{ width: "100%" }}>
                <Grid item style={{ width: "85%" }}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={cardDetails.additionalFields[key]}
                    disabled
                    sx={{ mb: 2 }}
                  />
                </Grid>
                <IconButton onClick={() => handleRemoveField(key)} sx={{ marginLeft: 1 }}>
                  <DeleteIcon />
                </IconButton>
              </div>
            </>
          ))}
          <Grid item style={{ width: "85%" }}>
            <TextField
              placeholder='Name'
              variant="standard"
              fullWidth
              value={newFieldName}
              onChange={(e) => setNewFieldName(e.target.value)}
              sx={{ mb: 2 }}
            />
          </Grid>
          <div className='d-flex align-items-center' style={{ width: "100%" }}>
            <Grid item style={{ width: "85%" }}>
              <TextField
                label="Input"
                variant="outlined"
                fullWidth
                value={newFieldValue}
                onChange={(e) => setNewFieldValue(e.target.value)}
                sx={{ mb: 2 }}
              />
            </Grid>
            <IconButton onClick={handleAddField} sx={{ marginLeft: 1 }}>
              <FaPlusCircle className="icon-color" />
            </IconButton>
          </div>
        </Box>
        <DialogActions>
          <Button onClick={() => setOpenDialogForNewField(false)} sx={{ backgroundColor: "#0044C6" }} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {isDialogNewEmail &&
        <Dialog
          open={isDialogNewEmail}
          // onClose={handleCloseVerifiedDialog}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">Two-factor Authentication</p>
                <p className="paragraph-text">Verify your new E-mail ID</p>
                <button type="button" className="lightbox__close" onClick={handlecloseDialog}>&times;</button>
                <div>
                  <div className=''>
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${showCodeError ? "error-textfield" : ""}`}
                      // InputProps={{
                      //     endAdornment: (
                      //         <InputAdornment position="end">
                      //             <IconButton onClick={toggleCodeVisibility}>
                      //                 {showCode ? (
                      //                     <VisibilityIcon />
                      //                 ) : (
                      //                     <VisibilityOffIcon />
                      //                 )}
                      //             </IconButton>
                      //         </InputAdornment>
                      //     ),
                      // }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: '10px' }}>
                      </div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div className="next-button-container" style={{ gap: "16px" }}>
                        <button className={`next-btn ${code.trim() === '' ? "disabled" : ""}`}
                          type="submit" onClick={handleCodeSubmitNewEmail}
                          disabled={code.trim() === ''}>
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail? <button className="button-style-height" onClick={sendOtpNewEmail}>RESEND</button>
                    </div>

                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      }
    </div>
  );
};


export default GenzProfileDetails;